var Ce = Object.defineProperty;
var Ie = (e, t, s) => t in e ? Ce(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s;
var B = (e, t, s) => Ie(e, typeof t != "symbol" ? t + "" : t, s);
import { g as Ue, c as Z, a as J } from "./_commonjsHelpers-BItOPCY9.js";
import { B as te } from "./index-BZpqZYNM.js";
import { r as Pe } from "./index-D7cgykJH.js";
function Ae(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var W = { exports: {} };
const Oe = {}, qe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Oe
}, Symbol.toStringTag, { value: "Module" })), Ne = /* @__PURE__ */ Ue(qe);
var Me = W.exports, he;
function V() {
  return he || (he = 1, function(e, t) {
    (function(s, r) {
      e.exports = r();
    })(Me, function() {
      var s = s || function(r, i) {
        var n;
        if (typeof window < "u" && window.crypto && (n = window.crypto), typeof self < "u" && self.crypto && (n = self.crypto), typeof globalThis < "u" && globalThis.crypto && (n = globalThis.crypto), !n && typeof window < "u" && window.msCrypto && (n = window.msCrypto), !n && typeof Z < "u" && Z.crypto && (n = Z.crypto), !n && typeof Ae == "function")
          try {
            n = Ne;
          } catch {
          }
        var o = function() {
          if (n) {
            if (typeof n.getRandomValues == "function")
              try {
                return n.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof n.randomBytes == "function")
              try {
                return n.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, c = Object.create || /* @__PURE__ */ function() {
          function a() {
          }
          return function(d) {
            var u;
            return a.prototype = d, u = new a(), a.prototype = null, u;
          };
        }(), l = {}, h = l.lib = {}, p = h.Base = /* @__PURE__ */ function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(a) {
              var d = c(this);
              return a && d.mixIn(a), (!d.hasOwnProperty("init") || this.init === d.init) && (d.init = function() {
                d.$super.init.apply(this, arguments);
              }), d.init.prototype = d, d.$super = this, d;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var a = this.extend();
              return a.init.apply(a, arguments), a;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(a) {
              for (var d in a)
                a.hasOwnProperty(d) && (this[d] = a[d]);
              a.hasOwnProperty("toString") && (this.toString = a.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), g = h.WordArray = p.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(a, d) {
            a = this.words = a || [], d != i ? this.sigBytes = d : this.sigBytes = a.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(a) {
            return (a || v).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(a) {
            var d = this.words, u = a.words, w = this.sigBytes, y = a.sigBytes;
            if (this.clamp(), w % 4)
              for (var k = 0; k < y; k++) {
                var x = u[k >>> 2] >>> 24 - k % 4 * 8 & 255;
                d[w + k >>> 2] |= x << 24 - (w + k) % 4 * 8;
              }
            else
              for (var R = 0; R < y; R += 4)
                d[w + R >>> 2] = u[R >>> 2];
            return this.sigBytes += y, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var a = this.words, d = this.sigBytes;
            a[d >>> 2] &= 4294967295 << 32 - d % 4 * 8, a.length = r.ceil(d / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var a = p.clone.call(this);
            return a.words = this.words.slice(0), a;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(a) {
            for (var d = [], u = 0; u < a; u += 4)
              d.push(o());
            return new g.init(d, a);
          }
        }), S = l.enc = {}, v = S.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(a) {
            for (var d = a.words, u = a.sigBytes, w = [], y = 0; y < u; y++) {
              var k = d[y >>> 2] >>> 24 - y % 4 * 8 & 255;
              w.push((k >>> 4).toString(16)), w.push((k & 15).toString(16));
            }
            return w.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(a) {
            for (var d = a.length, u = [], w = 0; w < d; w += 2)
              u[w >>> 3] |= parseInt(a.substr(w, 2), 16) << 24 - w % 8 * 4;
            return new g.init(u, d / 2);
          }
        }, b = S.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(a) {
            for (var d = a.words, u = a.sigBytes, w = [], y = 0; y < u; y++) {
              var k = d[y >>> 2] >>> 24 - y % 4 * 8 & 255;
              w.push(String.fromCharCode(k));
            }
            return w.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(a) {
            for (var d = a.length, u = [], w = 0; w < d; w++)
              u[w >>> 2] |= (a.charCodeAt(w) & 255) << 24 - w % 4 * 8;
            return new g.init(u, d);
          }
        }, _ = S.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(a) {
            try {
              return decodeURIComponent(escape(b.stringify(a)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(a) {
            return b.parse(unescape(encodeURIComponent(a)));
          }
        }, m = h.BufferedBlockAlgorithm = p.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new g.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(a) {
            typeof a == "string" && (a = _.parse(a)), this._data.concat(a), this._nDataBytes += a.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(a) {
            var d, u = this._data, w = u.words, y = u.sigBytes, k = this.blockSize, x = k * 4, R = y / x;
            a ? R = r.ceil(R) : R = r.max((R | 0) - this._minBufferSize, 0);
            var A = R * k, T = r.min(A * 4, y);
            if (A) {
              for (var q = 0; q < A; q += k)
                this._doProcessBlock(w, q);
              d = w.splice(0, A), u.sigBytes -= T;
            }
            return new g.init(d, T);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var a = p.clone.call(this);
            return a._data = this._data.clone(), a;
          },
          _minBufferSize: 0
        });
        h.Hasher = m.extend({
          /**
           * Configuration options.
           */
          cfg: p.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(a) {
            this.cfg = this.cfg.extend(a), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            m.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(a) {
            return this._append(a), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(a) {
            a && this._append(a);
            var d = this._doFinalize();
            return d;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(a) {
            return function(d, u) {
              return new a.init(u).finalize(d);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(a) {
            return function(d, u) {
              return new E.HMAC.init(a, u).finalize(d);
            };
          }
        });
        var E = l.algo = {};
        return l;
      }(Math);
      return s;
    });
  }(W)), W.exports;
}
var He = V();
const je = /* @__PURE__ */ J(He);
var $ = { exports: {} }, Be = $.exports, ge;
function We() {
  return ge || (ge = 1, function(e, t) {
    (function(s, r) {
      e.exports = r(V());
    })(Be, function(s) {
      return function(r) {
        var i = s, n = i.lib, o = n.WordArray, c = n.Hasher, l = i.algo, h = [], p = [];
        (function() {
          function v(E) {
            for (var a = r.sqrt(E), d = 2; d <= a; d++)
              if (!(E % d))
                return !1;
            return !0;
          }
          function b(E) {
            return (E - (E | 0)) * 4294967296 | 0;
          }
          for (var _ = 2, m = 0; m < 64; )
            v(_) && (m < 8 && (h[m] = b(r.pow(_, 1 / 2))), p[m] = b(r.pow(_, 1 / 3)), m++), _++;
        })();
        var g = [], S = l.SHA256 = c.extend({
          _doReset: function() {
            this._hash = new o.init(h.slice(0));
          },
          _doProcessBlock: function(v, b) {
            for (var _ = this._hash.words, m = _[0], E = _[1], a = _[2], d = _[3], u = _[4], w = _[5], y = _[6], k = _[7], x = 0; x < 64; x++) {
              if (x < 16)
                g[x] = v[b + x] | 0;
              else {
                var R = g[x - 15], A = (R << 25 | R >>> 7) ^ (R << 14 | R >>> 18) ^ R >>> 3, T = g[x - 2], q = (T << 15 | T >>> 17) ^ (T << 13 | T >>> 19) ^ T >>> 10;
                g[x] = A + g[x - 7] + q + g[x - 16];
              }
              var H = u & w ^ ~u & y, G = m & E ^ m & a ^ E & a, Q = (m << 30 | m >>> 2) ^ (m << 19 | m >>> 13) ^ (m << 10 | m >>> 22), X = (u << 26 | u >>> 6) ^ (u << 21 | u >>> 11) ^ (u << 7 | u >>> 25), j = k + X + H + p[x] + g[x], Y = Q + G;
              k = y, y = w, w = u, u = d + j | 0, d = a, a = E, E = m, m = j + Y | 0;
            }
            _[0] = _[0] + m | 0, _[1] = _[1] + E | 0, _[2] = _[2] + a | 0, _[3] = _[3] + d | 0, _[4] = _[4] + u | 0, _[5] = _[5] + w | 0, _[6] = _[6] + y | 0, _[7] = _[7] + k | 0;
          },
          _doFinalize: function() {
            var v = this._data, b = v.words, _ = this._nDataBytes * 8, m = v.sigBytes * 8;
            return b[m >>> 5] |= 128 << 24 - m % 32, b[(m + 64 >>> 9 << 4) + 14] = r.floor(_ / 4294967296), b[(m + 64 >>> 9 << 4) + 15] = _, v.sigBytes = b.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var v = c.clone.call(this);
            return v._hash = this._hash.clone(), v;
          }
        });
        i.SHA256 = c._createHelper(S), i.HmacSHA256 = c._createHmacHelper(S);
      }(Math), s.SHA256;
    });
  }($)), $.exports;
}
var $e = We();
const Fe = /* @__PURE__ */ J($e);
var F = { exports: {} }, Le = F.exports, ue;
function ze() {
  return ue || (ue = 1, function(e, t) {
    (function(s, r) {
      e.exports = r(V());
    })(Le, function(s) {
      return function() {
        var r = s, i = r.lib, n = i.WordArray, o = r.enc;
        o.Base64 = {
          /**
           * Converts a word array to a Base64 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Base64 string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
           */
          stringify: function(l) {
            var h = l.words, p = l.sigBytes, g = this._map;
            l.clamp();
            for (var S = [], v = 0; v < p; v += 3)
              for (var b = h[v >>> 2] >>> 24 - v % 4 * 8 & 255, _ = h[v + 1 >>> 2] >>> 24 - (v + 1) % 4 * 8 & 255, m = h[v + 2 >>> 2] >>> 24 - (v + 2) % 4 * 8 & 255, E = b << 16 | _ << 8 | m, a = 0; a < 4 && v + a * 0.75 < p; a++)
                S.push(g.charAt(E >>> 6 * (3 - a) & 63));
            var d = g.charAt(64);
            if (d)
              for (; S.length % 4; )
                S.push(d);
            return S.join("");
          },
          /**
           * Converts a Base64 string to a word array.
           *
           * @param {string} base64Str The Base64 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
           */
          parse: function(l) {
            var h = l.length, p = this._map, g = this._reverseMap;
            if (!g) {
              g = this._reverseMap = [];
              for (var S = 0; S < p.length; S++)
                g[p.charCodeAt(S)] = S;
            }
            var v = p.charAt(64);
            if (v) {
              var b = l.indexOf(v);
              b !== -1 && (h = b);
            }
            return c(l, h, g);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function c(l, h, p) {
          for (var g = [], S = 0, v = 0; v < h; v++)
            if (v % 4) {
              var b = p[l.charCodeAt(v - 1)] << v % 4 * 2, _ = p[l.charCodeAt(v)] >>> 6 - v % 4 * 2, m = b | _;
              g[S >>> 2] |= m << 24 - S % 4 * 8, S++;
            }
          return n.create(g, S);
        }
      }(), s.enc.Base64;
    });
  }(F)), F.exports;
}
var De = ze();
const _e = /* @__PURE__ */ J(De);
var L = { exports: {} }, Ke = L.exports, pe;
function Je() {
  return pe || (pe = 1, function(e, t) {
    (function(s, r) {
      e.exports = r(V());
    })(Ke, function(s) {
      return s.enc.Utf8;
    });
  }(L)), L.exports;
}
var Ve = Je();
const Ge = /* @__PURE__ */ J(Ve);
function se(e) {
  this.message = e;
}
se.prototype = new Error(), se.prototype.name = "InvalidCharacterError";
var fe = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1) throw new se("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var s, r, i = 0, n = 0, o = ""; r = t.charAt(n++); ~r && (s = i % 4 ? 64 * s + r : r, i++ % 4) ? o += String.fromCharCode(255 & s >> (-2 * i & 6)) : 0) r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(r);
  return o;
};
function Qe(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(s) {
      return decodeURIComponent(fe(s).replace(/(.)/g, function(r, i) {
        var n = i.charCodeAt(0).toString(16).toUpperCase();
        return n.length < 2 && (n = "0" + n), "%" + n;
      }));
    }(t);
  } catch {
    return fe(t);
  }
}
function D(e) {
  this.message = e;
}
function Xe(e, t) {
  if (typeof e != "string") throw new D("Invalid token specified");
  var s = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(Qe(e.split(".")[s]));
  } catch (r) {
    throw new D("Invalid token specified: " + r.message);
  }
}
D.prototype = new Error(), D.prototype.name = "InvalidTokenError";
var Ye = {
  debug: () => {
  },
  info: () => {
  },
  warn: () => {
  },
  error: () => {
  }
}, I, U, K = /* @__PURE__ */ ((e) => (e[e.NONE = 0] = "NONE", e[e.ERROR = 1] = "ERROR", e[e.WARN = 2] = "WARN", e[e.INFO = 3] = "INFO", e[e.DEBUG = 4] = "DEBUG", e))(K || {});
((e) => {
  function t() {
    I = 3, U = Ye;
  }
  e.reset = t;
  function s(i) {
    if (!(0 <= i && i <= 4))
      throw new Error("Invalid log level");
    I = i;
  }
  e.setLevel = s;
  function r(i) {
    U = i;
  }
  e.setLogger = r;
})(K || (K = {}));
var f = class {
  constructor(e) {
    this._name = e;
  }
  /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
  debug(...e) {
    I >= 4 && U.debug(f._format(this._name, this._method), ...e);
  }
  info(...e) {
    I >= 3 && U.info(f._format(this._name, this._method), ...e);
  }
  warn(...e) {
    I >= 2 && U.warn(f._format(this._name, this._method), ...e);
  }
  error(...e) {
    I >= 1 && U.error(f._format(this._name, this._method), ...e);
  }
  /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */
  throw(e) {
    throw this.error(e), e;
  }
  create(e) {
    const t = Object.create(this);
    return t._method = e, t.debug("begin"), t;
  }
  static createStatic(e, t) {
    const s = new f(`${e}.${t}`);
    return s.debug("begin"), s;
  }
  static _format(e, t) {
    const s = `[${e}]`;
    return t ? `${s} ${t}:` : s;
  }
  /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
  // helpers for static class methods
  static debug(e, ...t) {
    I >= 4 && U.debug(f._format(e), ...t);
  }
  static info(e, ...t) {
    I >= 3 && U.info(f._format(e), ...t);
  }
  static warn(e, ...t) {
    I >= 2 && U.warn(f._format(e), ...t);
  }
  static error(e, ...t) {
    I >= 1 && U.error(f._format(e), ...t);
  }
  /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */
};
K.reset();
var Ze = "10000000-1000-4000-8000-100000000000", P = class {
  static _randomWord() {
    return je.lib.WordArray.random(1).words[0];
  }
  /**
   * Generates RFC4122 version 4 guid
   */
  static generateUUIDv4() {
    return Ze.replace(
      /[018]/g,
      (t) => (+t ^ P._randomWord() & 15 >> +t / 4).toString(16)
    ).replace(/-/g, "");
  }
  /**
   * PKCE: Generate a code verifier
   */
  static generateCodeVerifier() {
    return P.generateUUIDv4() + P.generateUUIDv4() + P.generateUUIDv4();
  }
  /**
   * PKCE: Generate a code challenge
   */
  static generateCodeChallenge(e) {
    try {
      const t = Fe(e);
      return _e.stringify(t).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    } catch (t) {
      throw f.error("CryptoUtils.generateCodeChallenge", t), t;
    }
  }
  /**
   * Generates a base64-encoded string for a basic auth header
   */
  static generateBasicAuth(e, t) {
    const s = Ge.parse([e, t].join(":"));
    return _e.stringify(s);
  }
}, O = class {
  constructor(e) {
    this._name = e, this._logger = new f(`Event('${this._name}')`), this._callbacks = [];
  }
  addHandler(e) {
    return this._callbacks.push(e), () => this.removeHandler(e);
  }
  removeHandler(e) {
    const t = this._callbacks.lastIndexOf(e);
    t >= 0 && this._callbacks.splice(t, 1);
  }
  raise(...e) {
    this._logger.debug("raise:", ...e);
    for (const t of this._callbacks)
      t(...e);
  }
}, re = class {
  // IMPORTANT: doesn't validate the token
  static decode(e) {
    try {
      return Xe(e);
    } catch (t) {
      throw f.error("JwtUtils.decode", t), t;
    }
  }
}, we = class {
  /**
   * Populates a map of window features with a placement centered in front of
   * the current window. If no explicit width is given, a default value is
   * binned into [800, 720, 600, 480, 360] based on the current window's width.
   */
  static center({ ...e }) {
    var t, s, r;
    return e.width == null && (e.width = (t = [800, 720, 600, 480].find((i) => i <= window.outerWidth / 1.618)) != null ? t : 360), (s = e.left) != null || (e.left = Math.max(0, Math.round(window.screenX + (window.outerWidth - e.width) / 2))), e.height != null && ((r = e.top) != null || (e.top = Math.max(0, Math.round(window.screenY + (window.outerHeight - e.height) / 2)))), e;
  }
  static serialize(e) {
    return Object.entries(e).filter(([, t]) => t != null).map(([t, s]) => `${t}=${typeof s != "boolean" ? s : s ? "yes" : "no"}`).join(",");
  }
}, C = class extends O {
  constructor() {
    super(...arguments), this._logger = new f(`Timer('${this._name}')`), this._timerHandle = null, this._expiration = 0, this._callback = () => {
      const e = this._expiration - C.getEpochTime();
      this._logger.debug("timer completes in", e), this._expiration <= C.getEpochTime() && (this.cancel(), super.raise());
    };
  }
  // get the time
  static getEpochTime() {
    return Math.floor(Date.now() / 1e3);
  }
  init(e) {
    const t = this._logger.create("init");
    e = Math.max(Math.floor(e), 1);
    const s = C.getEpochTime() + e;
    if (this.expiration === s && this._timerHandle) {
      t.debug("skipping since already initialized for expiration at", this.expiration);
      return;
    }
    this.cancel(), t.debug("using duration", e), this._expiration = s;
    const r = Math.min(e, 5);
    this._timerHandle = setInterval(this._callback, r * 1e3);
  }
  get expiration() {
    return this._expiration;
  }
  cancel() {
    this._logger.create("cancel"), this._timerHandle && (clearInterval(this._timerHandle), this._timerHandle = null);
  }
}, ie = class {
  static readParams(e, t = "query") {
    if (!e)
      throw new TypeError("Invalid URL");
    const r = new URL(e, "http://127.0.0.1")[t === "fragment" ? "hash" : "search"];
    return new URLSearchParams(r.slice(1));
  }
}, ne = ";", N = class extends Error {
  constructor(e, t) {
    var s, r, i;
    if (super(e.error_description || e.error || ""), this.form = t, this.name = "ErrorResponse", !e.error)
      throw f.error("ErrorResponse", "No error passed"), new Error("No error passed");
    this.error = e.error, this.error_description = (s = e.error_description) != null ? s : null, this.error_uri = (r = e.error_uri) != null ? r : null, this.state = e.userState, this.session_state = (i = e.session_state) != null ? i : null, this.url_state = e.url_state;
  }
}, ce = class extends Error {
  constructor(e) {
    super(e), this.name = "ErrorTimeout";
  }
}, et = class {
  constructor(e) {
    this._logger = new f("AccessTokenEvents"), this._expiringTimer = new C("Access token expiring"), this._expiredTimer = new C("Access token expired"), this._expiringNotificationTimeInSeconds = e.expiringNotificationTimeInSeconds;
  }
  load(e) {
    const t = this._logger.create("load");
    if (e.access_token && e.expires_in !== void 0) {
      const s = e.expires_in;
      if (t.debug("access token present, remaining duration:", s), s > 0) {
        let i = s - this._expiringNotificationTimeInSeconds;
        i <= 0 && (i = 1), t.debug("registering expiring timer, raising in", i, "seconds"), this._expiringTimer.init(i);
      } else
        t.debug("canceling existing expiring timer because we're past expiration."), this._expiringTimer.cancel();
      const r = s + 1;
      t.debug("registering expired timer, raising in", r, "seconds"), this._expiredTimer.init(r);
    } else
      this._expiringTimer.cancel(), this._expiredTimer.cancel();
  }
  unload() {
    this._logger.debug("unload: canceling existing access token timers"), this._expiringTimer.cancel(), this._expiredTimer.cancel();
  }
  /**
   * Add callback: Raised prior to the access token expiring.
   */
  addAccessTokenExpiring(e) {
    return this._expiringTimer.addHandler(e);
  }
  /**
   * Remove callback: Raised prior to the access token expiring.
   */
  removeAccessTokenExpiring(e) {
    this._expiringTimer.removeHandler(e);
  }
  /**
   * Add callback: Raised after the access token has expired.
   */
  addAccessTokenExpired(e) {
    return this._expiredTimer.addHandler(e);
  }
  /**
   * Remove callback: Raised after the access token has expired.
   */
  removeAccessTokenExpired(e) {
    this._expiredTimer.removeHandler(e);
  }
}, tt = class {
  constructor(e, t, s, r, i) {
    this._callback = e, this._client_id = t, this._intervalInSeconds = r, this._stopOnError = i, this._logger = new f("CheckSessionIFrame"), this._timer = null, this._session_state = null, this._message = (o) => {
      o.origin === this._frame_origin && o.source === this._frame.contentWindow && (o.data === "error" ? (this._logger.error("error message from check session op iframe"), this._stopOnError && this.stop()) : o.data === "changed" ? (this._logger.debug("changed message from check session op iframe"), this.stop(), this._callback()) : this._logger.debug(o.data + " message from check session op iframe"));
    };
    const n = new URL(s);
    this._frame_origin = n.origin, this._frame = window.document.createElement("iframe"), this._frame.style.visibility = "hidden", this._frame.style.position = "fixed", this._frame.style.left = "-1000px", this._frame.style.top = "0", this._frame.width = "0", this._frame.height = "0", this._frame.src = n.href;
  }
  load() {
    return new Promise((e) => {
      this._frame.onload = () => {
        e();
      }, window.document.body.appendChild(this._frame), window.addEventListener("message", this._message, !1);
    });
  }
  start(e) {
    if (this._session_state === e)
      return;
    this._logger.create("start"), this.stop(), this._session_state = e;
    const t = () => {
      !this._frame.contentWindow || !this._session_state || this._frame.contentWindow.postMessage(this._client_id + " " + this._session_state, this._frame_origin);
    };
    t(), this._timer = setInterval(t, this._intervalInSeconds * 1e3);
  }
  stop() {
    this._logger.create("stop"), this._session_state = null, this._timer && (clearInterval(this._timer), this._timer = null);
  }
}, ye = class {
  constructor() {
    this._logger = new f("InMemoryWebStorage"), this._data = {};
  }
  clear() {
    this._logger.create("clear"), this._data = {};
  }
  getItem(e) {
    return this._logger.create(`getItem('${e}')`), this._data[e];
  }
  setItem(e, t) {
    this._logger.create(`setItem('${e}')`), this._data[e] = t;
  }
  removeItem(e) {
    this._logger.create(`removeItem('${e}')`), delete this._data[e];
  }
  get length() {
    return Object.getOwnPropertyNames(this._data).length;
  }
  key(e) {
    return Object.getOwnPropertyNames(this._data)[e];
  }
}, le = class {
  constructor(e = [], t = null, s = {}) {
    this._jwtHandler = t, this._extraHeaders = s, this._logger = new f("JsonService"), this._contentTypes = [], this._contentTypes.push(...e, "application/json"), t && this._contentTypes.push("application/jwt");
  }
  async fetchWithTimeout(e, t = {}) {
    const { timeoutInSeconds: s, ...r } = t;
    if (!s)
      return await fetch(e, r);
    const i = new AbortController(), n = setTimeout(() => i.abort(), s * 1e3);
    try {
      return await fetch(e, {
        ...t,
        signal: i.signal
      });
    } catch (o) {
      throw o instanceof DOMException && o.name === "AbortError" ? new ce("Network timed out") : o;
    } finally {
      clearTimeout(n);
    }
  }
  async getJson(e, {
    token: t,
    credentials: s
  } = {}) {
    const r = this._logger.create("getJson"), i = {
      Accept: this._contentTypes.join(", ")
    };
    t && (r.debug("token passed, setting Authorization header"), i.Authorization = "Bearer " + t), this.appendExtraHeaders(i);
    let n;
    try {
      r.debug("url:", e), n = await this.fetchWithTimeout(e, { method: "GET", headers: i, credentials: s });
    } catch (l) {
      throw r.error("Network Error"), l;
    }
    r.debug("HTTP response received, status", n.status);
    const o = n.headers.get("Content-Type");
    if (o && !this._contentTypes.find((l) => o.startsWith(l)) && r.throw(new Error(`Invalid response Content-Type: ${o ?? "undefined"}, from URL: ${e}`)), n.ok && this._jwtHandler && (o != null && o.startsWith("application/jwt")))
      return await this._jwtHandler(await n.text());
    let c;
    try {
      c = await n.json();
    } catch (l) {
      throw r.error("Error parsing JSON response", l), n.ok ? l : new Error(`${n.statusText} (${n.status})`);
    }
    if (!n.ok)
      throw r.error("Error from server:", c), c.error ? new N(c) : new Error(`${n.statusText} (${n.status}): ${JSON.stringify(c)}`);
    return c;
  }
  async postForm(e, {
    body: t,
    basicAuth: s,
    timeoutInSeconds: r,
    initCredentials: i
  }) {
    const n = this._logger.create("postForm"), o = {
      Accept: this._contentTypes.join(", "),
      "Content-Type": "application/x-www-form-urlencoded"
    };
    s !== void 0 && (o.Authorization = "Basic " + s), this.appendExtraHeaders(o);
    let c;
    try {
      n.debug("url:", e), c = await this.fetchWithTimeout(e, { method: "POST", headers: o, body: t, timeoutInSeconds: r, credentials: i });
    } catch (g) {
      throw n.error("Network error"), g;
    }
    n.debug("HTTP response received, status", c.status);
    const l = c.headers.get("Content-Type");
    if (l && !this._contentTypes.find((g) => l.startsWith(g)))
      throw new Error(`Invalid response Content-Type: ${l ?? "undefined"}, from URL: ${e}`);
    const h = await c.text();
    let p = {};
    if (h)
      try {
        p = JSON.parse(h);
      } catch (g) {
        throw n.error("Error parsing JSON response", g), c.ok ? g : new Error(`${c.statusText} (${c.status})`);
      }
    if (!c.ok)
      throw n.error("Error from server:", p), p.error ? new N(p, t) : new Error(`${c.statusText} (${c.status}): ${JSON.stringify(p)}`);
    return p;
  }
  appendExtraHeaders(e) {
    const t = this._logger.create("appendExtraHeaders"), s = Object.keys(this._extraHeaders), r = [
      "authorization",
      "accept",
      "content-type"
    ];
    s.length !== 0 && s.forEach((i) => {
      if (r.includes(i.toLocaleLowerCase())) {
        t.warn("Protected header could not be overridden", i, r);
        return;
      }
      const n = typeof this._extraHeaders[i] == "function" ? this._extraHeaders[i]() : this._extraHeaders[i];
      n && n !== "" && (e[i] = n);
    });
  }
}, st = class {
  constructor(e) {
    this._settings = e, this._logger = new f("MetadataService"), this._signingKeys = null, this._metadata = null, this._metadataUrl = this._settings.metadataUrl, this._jsonService = new le(
      ["application/jwk-set+json"],
      null,
      this._settings.extraHeaders
    ), this._settings.signingKeys && (this._logger.debug("using signingKeys from settings"), this._signingKeys = this._settings.signingKeys), this._settings.metadata && (this._logger.debug("using metadata from settings"), this._metadata = this._settings.metadata), this._settings.fetchRequestCredentials && (this._logger.debug("using fetchRequestCredentials from settings"), this._fetchRequestCredentials = this._settings.fetchRequestCredentials);
  }
  resetSigningKeys() {
    this._signingKeys = null;
  }
  async getMetadata() {
    const e = this._logger.create("getMetadata");
    if (this._metadata)
      return e.debug("using cached values"), this._metadata;
    if (!this._metadataUrl)
      throw e.throw(new Error("No authority or metadataUrl configured on settings")), null;
    e.debug("getting metadata from", this._metadataUrl);
    const t = await this._jsonService.getJson(this._metadataUrl, { credentials: this._fetchRequestCredentials });
    return e.debug("merging remote JSON with seed metadata"), this._metadata = Object.assign({}, this._settings.metadataSeed, t), this._metadata;
  }
  getIssuer() {
    return this._getMetadataProperty("issuer");
  }
  getAuthorizationEndpoint() {
    return this._getMetadataProperty("authorization_endpoint");
  }
  getUserInfoEndpoint() {
    return this._getMetadataProperty("userinfo_endpoint");
  }
  getTokenEndpoint(e = !0) {
    return this._getMetadataProperty("token_endpoint", e);
  }
  getCheckSessionIframe() {
    return this._getMetadataProperty("check_session_iframe", !0);
  }
  getEndSessionEndpoint() {
    return this._getMetadataProperty("end_session_endpoint", !0);
  }
  getRevocationEndpoint(e = !0) {
    return this._getMetadataProperty("revocation_endpoint", e);
  }
  getKeysEndpoint(e = !0) {
    return this._getMetadataProperty("jwks_uri", e);
  }
  async _getMetadataProperty(e, t = !1) {
    const s = this._logger.create(`_getMetadataProperty('${e}')`), r = await this.getMetadata();
    if (s.debug("resolved"), r[e] === void 0) {
      if (t === !0) {
        s.warn("Metadata does not contain optional property");
        return;
      }
      s.throw(new Error("Metadata does not contain property " + e));
    }
    return r[e];
  }
  async getSigningKeys() {
    const e = this._logger.create("getSigningKeys");
    if (this._signingKeys)
      return e.debug("returning signingKeys from cache"), this._signingKeys;
    const t = await this.getKeysEndpoint(!1);
    e.debug("got jwks_uri", t);
    const s = await this._jsonService.getJson(t);
    if (e.debug("got key set", s), !Array.isArray(s.keys))
      throw e.throw(new Error("Missing keys on keyset")), null;
    return this._signingKeys = s.keys, this._signingKeys;
  }
}, be = class {
  constructor({
    prefix: e = "oidc.",
    store: t = localStorage
  } = {}) {
    this._logger = new f("WebStorageStateStore"), this._store = t, this._prefix = e;
  }
  async set(e, t) {
    this._logger.create(`set('${e}')`), e = this._prefix + e, await this._store.setItem(e, t);
  }
  async get(e) {
    return this._logger.create(`get('${e}')`), e = this._prefix + e, await this._store.getItem(e);
  }
  async remove(e) {
    this._logger.create(`remove('${e}')`), e = this._prefix + e;
    const t = await this._store.getItem(e);
    return await this._store.removeItem(e), t;
  }
  async getAllKeys() {
    this._logger.create("getAllKeys");
    const e = await this._store.length, t = [];
    for (let s = 0; s < e; s++) {
      const r = await this._store.key(s);
      r && r.indexOf(this._prefix) === 0 && t.push(r.substr(this._prefix.length));
    }
    return t;
  }
}, rt = "code", it = "openid", nt = "client_secret_post", ot = "query", at = 60 * 15, ct = 60 * 5, oe = class {
  constructor({
    // metadata related
    authority: e,
    metadataUrl: t,
    metadata: s,
    signingKeys: r,
    metadataSeed: i,
    // client related
    client_id: n,
    client_secret: o,
    response_type: c = rt,
    scope: l = it,
    redirect_uri: h,
    post_logout_redirect_uri: p,
    client_authentication: g = nt,
    // optional protocol
    prompt: S,
    display: v,
    max_age: b,
    ui_locales: _,
    acr_values: m,
    resource: E,
    response_mode: a = ot,
    // behavior flags
    filterProtocolClaims: d = !0,
    loadUserInfo: u = !1,
    staleStateAgeInSeconds: w = at,
    clockSkewInSeconds: y = ct,
    userInfoJwtIssuer: k = "OP",
    mergeClaims: x = !1,
    disablePKCE: R = !1,
    // other behavior
    stateStore: A,
    refreshTokenCredentials: T,
    revokeTokenAdditionalContentTypes: q,
    fetchRequestCredentials: H,
    refreshTokenAllowedScope: G,
    // extra
    extraQueryParams: Q = {},
    extraTokenParams: X = {},
    extraHeaders: j = {}
  }) {
    if (this.authority = e, t ? this.metadataUrl = t : (this.metadataUrl = e, e && (this.metadataUrl.endsWith("/") || (this.metadataUrl += "/"), this.metadataUrl += ".well-known/openid-configuration")), this.metadata = s, this.metadataSeed = i, this.signingKeys = r, this.client_id = n, this.client_secret = o, this.response_type = c, this.scope = l, this.redirect_uri = h, this.post_logout_redirect_uri = p, this.client_authentication = g, this.prompt = S, this.display = v, this.max_age = b, this.ui_locales = _, this.acr_values = m, this.resource = E, this.response_mode = a, this.filterProtocolClaims = d ?? !0, this.loadUserInfo = !!u, this.staleStateAgeInSeconds = w, this.clockSkewInSeconds = y, this.userInfoJwtIssuer = k, this.mergeClaims = !!x, this.disablePKCE = !!R, this.revokeTokenAdditionalContentTypes = q, H && T && console.warn("Both fetchRequestCredentials and refreshTokenCredentials is set. Only fetchRequestCredentials will be used."), this.fetchRequestCredentials = H || T || "same-origin", A)
      this.stateStore = A;
    else {
      const Y = typeof window < "u" ? window.localStorage : new ye();
      this.stateStore = new be({ store: Y });
    }
    this.refreshTokenAllowedScope = G, this.extraQueryParams = Q, this.extraTokenParams = X, this.extraHeaders = j;
  }
}, lt = class {
  constructor(e, t) {
    this._settings = e, this._metadataService = t, this._logger = new f("UserInfoService"), this._getClaimsFromJwt = async (s) => {
      const r = this._logger.create("_getClaimsFromJwt");
      try {
        const i = re.decode(s);
        return r.debug("JWT decoding successful"), i;
      } catch (i) {
        throw r.error("Error parsing JWT response"), i;
      }
    }, this._jsonService = new le(
      void 0,
      this._getClaimsFromJwt,
      this._settings.extraHeaders
    );
  }
  async getClaims(e) {
    const t = this._logger.create("getClaims");
    e || this._logger.throw(new Error("No token passed"));
    const s = await this._metadataService.getUserInfoEndpoint();
    t.debug("got userinfo url", s);
    const r = await this._jsonService.getJson(s, {
      token: e,
      credentials: this._settings.fetchRequestCredentials
    });
    return t.debug("got claims", r), r;
  }
}, ke = class {
  constructor(e, t) {
    this._settings = e, this._metadataService = t, this._logger = new f("TokenClient"), this._jsonService = new le(
      this._settings.revokeTokenAdditionalContentTypes,
      null,
      this._settings.extraHeaders
    );
  }
  /**
   * Exchange code.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.1.3
   */
  async exchangeCode({
    grant_type: e = "authorization_code",
    redirect_uri: t = this._settings.redirect_uri,
    client_id: s = this._settings.client_id,
    client_secret: r = this._settings.client_secret,
    ...i
  }) {
    const n = this._logger.create("exchangeCode");
    s || n.throw(new Error("A client_id is required")), t || n.throw(new Error("A redirect_uri is required")), i.code || n.throw(new Error("A code is required"));
    const o = new URLSearchParams({ grant_type: e, redirect_uri: t });
    for (const [p, g] of Object.entries(i))
      g != null && o.set(p, g);
    let c;
    switch (this._settings.client_authentication) {
      case "client_secret_basic":
        if (!r)
          throw n.throw(new Error("A client_secret is required")), null;
        c = P.generateBasicAuth(s, r);
        break;
      case "client_secret_post":
        o.append("client_id", s), r && o.append("client_secret", r);
        break;
    }
    const l = await this._metadataService.getTokenEndpoint(!1);
    n.debug("got token endpoint");
    const h = await this._jsonService.postForm(l, { body: o, basicAuth: c, initCredentials: this._settings.fetchRequestCredentials });
    return n.debug("got response"), h;
  }
  /**
   * Exchange credentials.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.3.2
   */
  async exchangeCredentials({
    grant_type: e = "password",
    client_id: t = this._settings.client_id,
    client_secret: s = this._settings.client_secret,
    scope: r = this._settings.scope,
    ...i
  }) {
    const n = this._logger.create("exchangeCredentials");
    t || n.throw(new Error("A client_id is required"));
    const o = new URLSearchParams({ grant_type: e, scope: r });
    for (const [p, g] of Object.entries(i))
      g != null && o.set(p, g);
    let c;
    switch (this._settings.client_authentication) {
      case "client_secret_basic":
        if (!s)
          throw n.throw(new Error("A client_secret is required")), null;
        c = P.generateBasicAuth(t, s);
        break;
      case "client_secret_post":
        o.append("client_id", t), s && o.append("client_secret", s);
        break;
    }
    const l = await this._metadataService.getTokenEndpoint(!1);
    n.debug("got token endpoint");
    const h = await this._jsonService.postForm(l, { body: o, basicAuth: c, initCredentials: this._settings.fetchRequestCredentials });
    return n.debug("got response"), h;
  }
  /**
   * Exchange a refresh token.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-6
   */
  async exchangeRefreshToken({
    grant_type: e = "refresh_token",
    client_id: t = this._settings.client_id,
    client_secret: s = this._settings.client_secret,
    timeoutInSeconds: r,
    ...i
  }) {
    const n = this._logger.create("exchangeRefreshToken");
    t || n.throw(new Error("A client_id is required")), i.refresh_token || n.throw(new Error("A refresh_token is required"));
    const o = new URLSearchParams({ grant_type: e });
    for (const [p, g] of Object.entries(i))
      Array.isArray(g) ? g.forEach((S) => o.append(p, S)) : g != null && o.set(p, g);
    let c;
    switch (this._settings.client_authentication) {
      case "client_secret_basic":
        if (!s)
          throw n.throw(new Error("A client_secret is required")), null;
        c = P.generateBasicAuth(t, s);
        break;
      case "client_secret_post":
        o.append("client_id", t), s && o.append("client_secret", s);
        break;
    }
    const l = await this._metadataService.getTokenEndpoint(!1);
    n.debug("got token endpoint");
    const h = await this._jsonService.postForm(l, { body: o, basicAuth: c, timeoutInSeconds: r, initCredentials: this._settings.fetchRequestCredentials });
    return n.debug("got response"), h;
  }
  /**
   * Revoke an access or refresh token.
   *
   * @see https://datatracker.ietf.org/doc/html/rfc7009#section-2.1
   */
  async revoke(e) {
    var t;
    const s = this._logger.create("revoke");
    e.token || s.throw(new Error("A token is required"));
    const r = await this._metadataService.getRevocationEndpoint(!1);
    s.debug(`got revocation endpoint, revoking ${(t = e.token_type_hint) != null ? t : "default token type"}`);
    const i = new URLSearchParams();
    for (const [n, o] of Object.entries(e))
      o != null && i.set(n, o);
    i.set("client_id", this._settings.client_id), this._settings.client_secret && i.set("client_secret", this._settings.client_secret), await this._jsonService.postForm(r, { body: i }), s.debug("got response");
  }
}, dt = class {
  constructor(e, t, s) {
    this._settings = e, this._metadataService = t, this._claimsService = s, this._logger = new f("ResponseValidator"), this._userInfoService = new lt(this._settings, this._metadataService), this._tokenClient = new ke(this._settings, this._metadataService);
  }
  async validateSigninResponse(e, t) {
    const s = this._logger.create("validateSigninResponse");
    this._processSigninState(e, t), s.debug("state processed"), await this._processCode(e, t), s.debug("code processed"), e.isOpenId && this._validateIdTokenAttributes(e), s.debug("tokens validated"), await this._processClaims(e, t == null ? void 0 : t.skipUserInfo, e.isOpenId), s.debug("claims processed");
  }
  async validateCredentialsResponse(e, t) {
    const s = this._logger.create("validateCredentialsResponse");
    e.isOpenId && e.id_token && this._validateIdTokenAttributes(e), s.debug("tokens validated"), await this._processClaims(e, t, e.isOpenId), s.debug("claims processed");
  }
  async validateRefreshResponse(e, t) {
    var s, r;
    const i = this._logger.create("validateRefreshResponse");
    e.userState = t.data, (s = e.session_state) != null || (e.session_state = t.session_state), (r = e.scope) != null || (e.scope = t.scope), e.isOpenId && e.id_token && (this._validateIdTokenAttributes(e, t.id_token), i.debug("ID Token validated")), e.id_token || (e.id_token = t.id_token, e.profile = t.profile);
    const n = e.isOpenId && !!e.id_token;
    await this._processClaims(e, !1, n), i.debug("claims processed");
  }
  validateSignoutResponse(e, t) {
    const s = this._logger.create("validateSignoutResponse");
    if (t.id !== e.state && s.throw(new Error("State does not match")), s.debug("state validated"), e.userState = t.data, e.error)
      throw s.warn("Response was error", e.error), new N(e);
  }
  _processSigninState(e, t) {
    var s;
    const r = this._logger.create("_processSigninState");
    if (t.id !== e.state && r.throw(new Error("State does not match")), t.client_id || r.throw(new Error("No client_id on state")), t.authority || r.throw(new Error("No authority on state")), this._settings.authority !== t.authority && r.throw(new Error("authority mismatch on settings vs. signin state")), this._settings.client_id && this._settings.client_id !== t.client_id && r.throw(new Error("client_id mismatch on settings vs. signin state")), r.debug("state validated"), e.userState = t.data, e.url_state = t.url_state, (s = e.scope) != null || (e.scope = t.scope), e.error)
      throw r.warn("Response was error", e.error), new N(e);
    t.code_verifier && !e.code && r.throw(new Error("Expected code in response"));
  }
  async _processClaims(e, t = !1, s = !0) {
    const r = this._logger.create("_processClaims");
    if (e.profile = this._claimsService.filterProtocolClaims(e.profile), t || !this._settings.loadUserInfo || !e.access_token) {
      r.debug("not loading user info");
      return;
    }
    r.debug("loading user info");
    const i = await this._userInfoService.getClaims(e.access_token);
    r.debug("user info claims received from user info endpoint"), s && i.sub !== e.profile.sub && r.throw(new Error("subject from UserInfo response does not match subject in ID Token")), e.profile = this._claimsService.mergeClaims(e.profile, this._claimsService.filterProtocolClaims(i)), r.debug("user info claims received, updated profile:", e.profile);
  }
  async _processCode(e, t) {
    const s = this._logger.create("_processCode");
    if (e.code) {
      s.debug("Validating code");
      const r = await this._tokenClient.exchangeCode({
        client_id: t.client_id,
        client_secret: t.client_secret,
        code: e.code,
        redirect_uri: t.redirect_uri,
        code_verifier: t.code_verifier,
        ...t.extraTokenParams
      });
      Object.assign(e, r);
    } else
      s.debug("No code to process");
  }
  _validateIdTokenAttributes(e, t) {
    var s;
    const r = this._logger.create("_validateIdTokenAttributes");
    r.debug("decoding ID Token JWT");
    const i = re.decode((s = e.id_token) != null ? s : "");
    if (i.sub || r.throw(new Error("ID Token is missing a subject claim")), t) {
      const n = re.decode(t);
      i.sub !== n.sub && r.throw(new Error("sub in id_token does not match current sub")), i.auth_time && i.auth_time !== n.auth_time && r.throw(new Error("auth_time in id_token does not match original auth_time")), i.azp && i.azp !== n.azp && r.throw(new Error("azp in id_token does not match original azp")), !i.azp && n.azp && r.throw(new Error("azp not in id_token, but present in original id_token"));
    }
    e.profile = i;
  }
}, M = class {
  constructor(e) {
    this.id = e.id || P.generateUUIDv4(), this.data = e.data, e.created && e.created > 0 ? this.created = e.created : this.created = C.getEpochTime(), this.request_type = e.request_type, this.url_state = e.url_state;
  }
  toStorageString() {
    return new f("State").create("toStorageString"), JSON.stringify({
      id: this.id,
      data: this.data,
      created: this.created,
      request_type: this.request_type,
      url_state: this.url_state
    });
  }
  static fromStorageString(e) {
    return f.createStatic("State", "fromStorageString"), new M(JSON.parse(e));
  }
  static async clearStaleState(e, t) {
    const s = f.createStatic("State", "clearStaleState"), r = C.getEpochTime() - t, i = await e.getAllKeys();
    s.debug("got keys", i);
    for (let n = 0; n < i.length; n++) {
      const o = i[n], c = await e.get(o);
      let l = !1;
      if (c)
        try {
          const h = M.fromStorageString(c);
          s.debug("got item from key:", o, h.created), h.created <= r && (l = !0);
        } catch (h) {
          s.error("Error parsing state for key:", o, h), l = !0;
        }
      else
        s.debug("no item in storage for key:", o), l = !0;
      l && (s.debug("removed item for key:", o), e.remove(o));
    }
  }
}, de = class extends M {
  constructor(e) {
    super(e), e.code_verifier === !0 ? this.code_verifier = P.generateCodeVerifier() : e.code_verifier && (this.code_verifier = e.code_verifier), this.code_verifier && (this.code_challenge = P.generateCodeChallenge(this.code_verifier)), this.authority = e.authority, this.client_id = e.client_id, this.redirect_uri = e.redirect_uri, this.scope = e.scope, this.client_secret = e.client_secret, this.extraTokenParams = e.extraTokenParams, this.response_mode = e.response_mode, this.skipUserInfo = e.skipUserInfo;
  }
  toStorageString() {
    return new f("SigninState").create("toStorageString"), JSON.stringify({
      id: this.id,
      data: this.data,
      created: this.created,
      request_type: this.request_type,
      url_state: this.url_state,
      code_verifier: this.code_verifier,
      authority: this.authority,
      client_id: this.client_id,
      redirect_uri: this.redirect_uri,
      scope: this.scope,
      client_secret: this.client_secret,
      extraTokenParams: this.extraTokenParams,
      response_mode: this.response_mode,
      skipUserInfo: this.skipUserInfo
    });
  }
  static fromStorageString(e) {
    f.createStatic("SigninState", "fromStorageString");
    const t = JSON.parse(e);
    return new de(t);
  }
}, ht = class {
  constructor({
    // mandatory
    url: e,
    authority: t,
    client_id: s,
    redirect_uri: r,
    response_type: i,
    scope: n,
    // optional
    state_data: o,
    response_mode: c,
    request_type: l,
    client_secret: h,
    nonce: p,
    url_state: g,
    resource: S,
    skipUserInfo: v,
    extraQueryParams: b,
    extraTokenParams: _,
    disablePKCE: m,
    ...E
  }) {
    if (this._logger = new f("SigninRequest"), !e)
      throw this._logger.error("ctor: No url passed"), new Error("url");
    if (!s)
      throw this._logger.error("ctor: No client_id passed"), new Error("client_id");
    if (!r)
      throw this._logger.error("ctor: No redirect_uri passed"), new Error("redirect_uri");
    if (!i)
      throw this._logger.error("ctor: No response_type passed"), new Error("response_type");
    if (!n)
      throw this._logger.error("ctor: No scope passed"), new Error("scope");
    if (!t)
      throw this._logger.error("ctor: No authority passed"), new Error("authority");
    this.state = new de({
      data: o,
      request_type: l,
      url_state: g,
      code_verifier: !m,
      client_id: s,
      authority: t,
      redirect_uri: r,
      response_mode: c,
      client_secret: h,
      scope: n,
      extraTokenParams: _,
      skipUserInfo: v
    });
    const a = new URL(e);
    a.searchParams.append("client_id", s), a.searchParams.append("redirect_uri", r), a.searchParams.append("response_type", i), a.searchParams.append("scope", n), p && a.searchParams.append("nonce", p);
    let d = this.state.id;
    g && (d = `${d}${ne}${g}`), a.searchParams.append("state", d), this.state.code_challenge && (a.searchParams.append("code_challenge", this.state.code_challenge), a.searchParams.append("code_challenge_method", "S256")), S && (Array.isArray(S) ? S : [S]).forEach((w) => a.searchParams.append("resource", w));
    for (const [u, w] of Object.entries({ response_mode: c, ...E, ...b }))
      w != null && a.searchParams.append(u, w.toString());
    this.url = a.href;
  }
}, gt = "openid", ee = class {
  constructor(e) {
    if (this.access_token = "", this.token_type = "", this.profile = {}, this.state = e.get("state"), this.session_state = e.get("session_state"), this.state) {
      const t = decodeURIComponent(this.state).split(ne);
      this.state = t[0], t.length > 1 && (this.url_state = t.slice(1).join(ne));
    }
    this.error = e.get("error"), this.error_description = e.get("error_description"), this.error_uri = e.get("error_uri"), this.code = e.get("code");
  }
  get expires_in() {
    if (this.expires_at !== void 0)
      return this.expires_at - C.getEpochTime();
  }
  set expires_in(e) {
    typeof e == "string" && (e = Number(e)), e !== void 0 && e >= 0 && (this.expires_at = Math.floor(e) + C.getEpochTime());
  }
  get isOpenId() {
    var e;
    return ((e = this.scope) == null ? void 0 : e.split(" ").includes(gt)) || !!this.id_token;
  }
}, ut = class {
  constructor({
    url: e,
    state_data: t,
    id_token_hint: s,
    post_logout_redirect_uri: r,
    extraQueryParams: i,
    request_type: n,
    client_id: o
  }) {
    if (this._logger = new f("SignoutRequest"), !e)
      throw this._logger.error("ctor: No url passed"), new Error("url");
    const c = new URL(e);
    s && c.searchParams.append("id_token_hint", s), o && c.searchParams.append("client_id", o), r && (c.searchParams.append("post_logout_redirect_uri", r), t && (this.state = new M({ data: t, request_type: n }), c.searchParams.append("state", this.state.id)));
    for (const [l, h] of Object.entries({ ...i }))
      h != null && c.searchParams.append(l, h.toString());
    this.url = c.href;
  }
}, _t = class {
  constructor(e) {
    this.state = e.get("state"), this.error = e.get("error"), this.error_description = e.get("error_description"), this.error_uri = e.get("error_uri");
  }
}, pt = [
  "nbf",
  "jti",
  "auth_time",
  "nonce",
  "acr",
  "amr",
  "azp",
  "at_hash"
  // https://openid.net/specs/openid-connect-core-1_0.html#CodeIDToken
], ft = ["sub", "iss", "aud", "exp", "iat"], wt = class {
  constructor(e) {
    this._settings = e, this._logger = new f("ClaimsService");
  }
  filterProtocolClaims(e) {
    const t = { ...e };
    if (this._settings.filterProtocolClaims) {
      let s;
      Array.isArray(this._settings.filterProtocolClaims) ? s = this._settings.filterProtocolClaims : s = pt;
      for (const r of s)
        ft.includes(r) || delete t[r];
    }
    return t;
  }
  mergeClaims(e, t) {
    const s = { ...e };
    for (const [r, i] of Object.entries(t))
      for (const n of Array.isArray(i) ? i : [i]) {
        const o = s[r];
        o === void 0 ? s[r] = n : Array.isArray(o) ? o.includes(n) || o.push(n) : s[r] !== n && (typeof n == "object" && this._settings.mergeClaims ? s[r] = this.mergeClaims(o, n) : s[r] = [o, n]);
      }
    return s;
  }
}, vt = class {
  constructor(e, t) {
    this._logger = new f("OidcClient"), this.settings = e instanceof oe ? e : new oe(e), this.metadataService = t ?? new st(this.settings), this._claimsService = new wt(this.settings), this._validator = new dt(this.settings, this.metadataService, this._claimsService), this._tokenClient = new ke(this.settings, this.metadataService);
  }
  async createSigninRequest({
    state: e,
    request: t,
    request_uri: s,
    request_type: r,
    id_token_hint: i,
    login_hint: n,
    skipUserInfo: o,
    nonce: c,
    url_state: l,
    response_type: h = this.settings.response_type,
    scope: p = this.settings.scope,
    redirect_uri: g = this.settings.redirect_uri,
    prompt: S = this.settings.prompt,
    display: v = this.settings.display,
    max_age: b = this.settings.max_age,
    ui_locales: _ = this.settings.ui_locales,
    acr_values: m = this.settings.acr_values,
    resource: E = this.settings.resource,
    response_mode: a = this.settings.response_mode,
    extraQueryParams: d = this.settings.extraQueryParams,
    extraTokenParams: u = this.settings.extraTokenParams
  }) {
    const w = this._logger.create("createSigninRequest");
    if (h !== "code")
      throw new Error("Only the Authorization Code flow (with PKCE) is supported");
    const y = await this.metadataService.getAuthorizationEndpoint();
    w.debug("Received authorization endpoint", y);
    const k = new ht({
      url: y,
      authority: this.settings.authority,
      client_id: this.settings.client_id,
      redirect_uri: g,
      response_type: h,
      scope: p,
      state_data: e,
      url_state: l,
      prompt: S,
      display: v,
      max_age: b,
      ui_locales: _,
      id_token_hint: i,
      login_hint: n,
      acr_values: m,
      resource: E,
      request: t,
      request_uri: s,
      extraQueryParams: d,
      extraTokenParams: u,
      request_type: r,
      response_mode: a,
      client_secret: this.settings.client_secret,
      skipUserInfo: o,
      nonce: c,
      disablePKCE: this.settings.disablePKCE
    });
    await this.clearStaleState();
    const x = k.state;
    return await this.settings.stateStore.set(x.id, x.toStorageString()), k;
  }
  async readSigninResponseState(e, t = !1) {
    const s = this._logger.create("readSigninResponseState"), r = new ee(ie.readParams(e, this.settings.response_mode));
    if (!r.state)
      throw s.throw(new Error("No state in response")), null;
    const i = await this.settings.stateStore[t ? "remove" : "get"](r.state);
    if (!i)
      throw s.throw(new Error("No matching state found in storage")), null;
    return { state: de.fromStorageString(i), response: r };
  }
  async processSigninResponse(e) {
    const t = this._logger.create("processSigninResponse"), { state: s, response: r } = await this.readSigninResponseState(e, !0);
    return t.debug("received state from storage; validating response"), await this._validator.validateSigninResponse(r, s), r;
  }
  async processResourceOwnerPasswordCredentials({
    username: e,
    password: t,
    skipUserInfo: s = !1,
    extraTokenParams: r = {}
  }) {
    const i = await this._tokenClient.exchangeCredentials({ username: e, password: t, ...r }), n = new ee(new URLSearchParams());
    return Object.assign(n, i), await this._validator.validateCredentialsResponse(n, s), n;
  }
  async useRefreshToken({
    state: e,
    timeoutInSeconds: t
  }) {
    var s;
    const r = this._logger.create("useRefreshToken");
    let i;
    if (this.settings.refreshTokenAllowedScope === void 0)
      i = e.scope;
    else {
      const c = this.settings.refreshTokenAllowedScope.split(" ");
      i = (((s = e.scope) == null ? void 0 : s.split(" ")) || []).filter((h) => c.includes(h)).join(" ");
    }
    const n = await this._tokenClient.exchangeRefreshToken({
      refresh_token: e.refresh_token,
      resource: e.resource,
      // provide the (possible filtered) scope list
      scope: i,
      timeoutInSeconds: t
    }), o = new ee(new URLSearchParams());
    return Object.assign(o, n), r.debug("validating response", o), await this._validator.validateRefreshResponse(o, {
      ...e,
      // overide the scope in the state handed over to the validator
      // so it can set the granted scope to the requested scope in case none is included in the response
      scope: i
    }), o;
  }
  async createSignoutRequest({
    state: e,
    id_token_hint: t,
    client_id: s,
    request_type: r,
    post_logout_redirect_uri: i = this.settings.post_logout_redirect_uri,
    extraQueryParams: n = this.settings.extraQueryParams
  } = {}) {
    const o = this._logger.create("createSignoutRequest"), c = await this.metadataService.getEndSessionEndpoint();
    if (!c)
      throw o.throw(new Error("No end session endpoint")), null;
    o.debug("Received end session endpoint", c), !s && i && !t && (s = this.settings.client_id);
    const l = new ut({
      url: c,
      id_token_hint: t,
      client_id: s,
      post_logout_redirect_uri: i,
      state_data: e,
      extraQueryParams: n,
      request_type: r
    });
    await this.clearStaleState();
    const h = l.state;
    return h && (o.debug("Signout request has state to persist"), await this.settings.stateStore.set(h.id, h.toStorageString())), l;
  }
  async readSignoutResponseState(e, t = !1) {
    const s = this._logger.create("readSignoutResponseState"), r = new _t(ie.readParams(e, this.settings.response_mode));
    if (!r.state) {
      if (s.debug("No state in response"), r.error)
        throw s.warn("Response was error:", r.error), new N(r);
      return { state: void 0, response: r };
    }
    const i = await this.settings.stateStore[t ? "remove" : "get"](r.state);
    if (!i)
      throw s.throw(new Error("No matching state found in storage")), null;
    return { state: M.fromStorageString(i), response: r };
  }
  async processSignoutResponse(e) {
    const t = this._logger.create("processSignoutResponse"), { state: s, response: r } = await this.readSignoutResponseState(e, !0);
    return s ? (t.debug("Received state from storage; validating response"), this._validator.validateSignoutResponse(r, s)) : t.debug("No state from storage; skipping response validation"), r;
  }
  clearStaleState() {
    return this._logger.create("clearStaleState"), M.clearStaleState(this.settings.stateStore, this.settings.staleStateAgeInSeconds);
  }
  async revokeToken(e, t) {
    return this._logger.create("revokeToken"), await this._tokenClient.revoke({
      token: e,
      token_type_hint: t
    });
  }
}, mt = class {
  constructor(e) {
    this._userManager = e, this._logger = new f("SessionMonitor"), this._start = async (t) => {
      const s = t.session_state;
      if (!s)
        return;
      const r = this._logger.create("_start");
      if (t.profile ? (this._sub = t.profile.sub, this._sid = t.profile.sid, r.debug("session_state", s, ", sub", this._sub)) : (this._sub = void 0, this._sid = void 0, r.debug("session_state", s, ", anonymous user")), this._checkSessionIFrame) {
        this._checkSessionIFrame.start(s);
        return;
      }
      try {
        const i = await this._userManager.metadataService.getCheckSessionIframe();
        if (i) {
          r.debug("initializing check session iframe");
          const n = this._userManager.settings.client_id, o = this._userManager.settings.checkSessionIntervalInSeconds, c = this._userManager.settings.stopCheckSessionOnError, l = new tt(this._callback, n, i, o, c);
          await l.load(), this._checkSessionIFrame = l, l.start(s);
        } else
          r.warn("no check session iframe found in the metadata");
      } catch (i) {
        r.error("Error from getCheckSessionIframe:", i instanceof Error ? i.message : i);
      }
    }, this._stop = () => {
      const t = this._logger.create("_stop");
      if (this._sub = void 0, this._sid = void 0, this._checkSessionIFrame && this._checkSessionIFrame.stop(), this._userManager.settings.monitorAnonymousSession) {
        const s = setInterval(async () => {
          clearInterval(s);
          try {
            const r = await this._userManager.querySessionStatus();
            if (r) {
              const i = {
                session_state: r.session_state,
                profile: r.sub && r.sid ? {
                  sub: r.sub,
                  sid: r.sid
                } : null
              };
              this._start(i);
            }
          } catch (r) {
            t.error("error from querySessionStatus", r instanceof Error ? r.message : r);
          }
        }, 1e3);
      }
    }, this._callback = async () => {
      const t = this._logger.create("_callback");
      try {
        const s = await this._userManager.querySessionStatus();
        let r = !0;
        s && this._checkSessionIFrame ? s.sub === this._sub ? (r = !1, this._checkSessionIFrame.start(s.session_state), s.sid === this._sid ? t.debug("same sub still logged in at OP, restarting check session iframe; session_state", s.session_state) : (t.debug("same sub still logged in at OP, session state has changed, restarting check session iframe; session_state", s.session_state), this._userManager.events._raiseUserSessionChanged())) : t.debug("different subject signed into OP", s.sub) : t.debug("subject no longer signed into OP"), r ? this._sub ? this._userManager.events._raiseUserSignedOut() : this._userManager.events._raiseUserSignedIn() : t.debug("no change in session detected, no event to raise");
      } catch (s) {
        this._sub && (t.debug("Error calling queryCurrentSigninSession; raising signed out event", s), this._userManager.events._raiseUserSignedOut());
      }
    }, e || this._logger.throw(new Error("No user manager passed")), this._userManager.events.addUserLoaded(this._start), this._userManager.events.addUserUnloaded(this._stop), this._init().catch((t) => {
      this._logger.error(t);
    });
  }
  async _init() {
    this._logger.create("_init");
    const e = await this._userManager.getUser();
    if (e)
      this._start(e);
    else if (this._userManager.settings.monitorAnonymousSession) {
      const t = await this._userManager.querySessionStatus();
      if (t) {
        const s = {
          session_state: t.session_state,
          profile: t.sub && t.sid ? {
            sub: t.sub,
            sid: t.sid
          } : null
        };
        this._start(s);
      }
    }
  }
}, z = class {
  constructor(e) {
    var t;
    this.id_token = e.id_token, this.session_state = (t = e.session_state) != null ? t : null, this.access_token = e.access_token, this.refresh_token = e.refresh_token, this.token_type = e.token_type, this.scope = e.scope, this.profile = e.profile, this.expires_at = e.expires_at, this.state = e.userState, this.url_state = e.url_state;
  }
  /** Computed number of seconds the access token has remaining. */
  get expires_in() {
    if (this.expires_at !== void 0)
      return this.expires_at - C.getEpochTime();
  }
  set expires_in(e) {
    e !== void 0 && (this.expires_at = Math.floor(e) + C.getEpochTime());
  }
  /** Computed value indicating if the access token is expired. */
  get expired() {
    const e = this.expires_in;
    if (e !== void 0)
      return e <= 0;
  }
  /** Array representing the parsed values from the `scope`. */
  get scopes() {
    var e, t;
    return (t = (e = this.scope) == null ? void 0 : e.split(" ")) != null ? t : [];
  }
  toStorageString() {
    return new f("User").create("toStorageString"), JSON.stringify({
      id_token: this.id_token,
      session_state: this.session_state,
      access_token: this.access_token,
      refresh_token: this.refresh_token,
      token_type: this.token_type,
      scope: this.scope,
      profile: this.profile,
      expires_at: this.expires_at
    });
  }
  static fromStorageString(e) {
    return f.createStatic("User", "fromStorageString"), new z(JSON.parse(e));
  }
}, ve = "oidc-client", Ee = class {
  constructor() {
    this._abort = new O("Window navigation aborted"), this._disposeHandlers = /* @__PURE__ */ new Set(), this._window = null;
  }
  async navigate(e) {
    const t = this._logger.create("navigate");
    if (!this._window)
      throw new Error("Attempted to navigate on a disposed window");
    t.debug("setting URL in window"), this._window.location.replace(e.url);
    const { url: s, keepOpen: r } = await new Promise((i, n) => {
      const o = (c) => {
        var l;
        const h = c.data, p = (l = e.scriptOrigin) != null ? l : window.location.origin;
        if (!(c.origin !== p || (h == null ? void 0 : h.source) !== ve)) {
          try {
            const g = ie.readParams(h.url, e.response_mode).get("state");
            if (g || t.warn("no state found in response url"), c.source !== this._window && g !== e.state)
              return;
          } catch {
            this._dispose(), n(new Error("Invalid response from window"));
          }
          i(h);
        }
      };
      window.addEventListener("message", o, !1), this._disposeHandlers.add(() => window.removeEventListener("message", o, !1)), this._disposeHandlers.add(this._abort.addHandler((c) => {
        this._dispose(), n(c);
      }));
    });
    return t.debug("got response from window"), this._dispose(), r || this.close(), { url: s };
  }
  _dispose() {
    this._logger.create("_dispose");
    for (const e of this._disposeHandlers)
      e();
    this._disposeHandlers.clear();
  }
  static _notifyParent(e, t, s = !1, r = window.location.origin) {
    e.postMessage({
      source: ve,
      url: t,
      keepOpen: s
    }, r);
  }
}, xe = {
  location: !1,
  toolbar: !1,
  height: 640,
  closePopupWindowAfterInSeconds: -1
}, Re = "_blank", St = 60, yt = 2, Te = 10, bt = class extends oe {
  constructor(e) {
    const {
      popup_redirect_uri: t = e.redirect_uri,
      popup_post_logout_redirect_uri: s = e.post_logout_redirect_uri,
      popupWindowFeatures: r = xe,
      popupWindowTarget: i = Re,
      redirectMethod: n = "assign",
      redirectTarget: o = "self",
      iframeNotifyParentOrigin: c = e.iframeNotifyParentOrigin,
      iframeScriptOrigin: l = e.iframeScriptOrigin,
      silent_redirect_uri: h = e.redirect_uri,
      silentRequestTimeoutInSeconds: p = Te,
      automaticSilentRenew: g = !0,
      validateSubOnSilentRenew: S = !0,
      includeIdTokenInSilentRenew: v = !1,
      monitorSession: b = !1,
      monitorAnonymousSession: _ = !1,
      checkSessionIntervalInSeconds: m = yt,
      query_status_response_type: E = "code",
      stopCheckSessionOnError: a = !0,
      revokeTokenTypes: d = ["access_token", "refresh_token"],
      revokeTokensOnSignout: u = !1,
      includeIdTokenInSilentSignout: w = !1,
      accessTokenExpiringNotificationTimeInSeconds: y = St,
      userStore: k
    } = e;
    if (super(e), this.popup_redirect_uri = t, this.popup_post_logout_redirect_uri = s, this.popupWindowFeatures = r, this.popupWindowTarget = i, this.redirectMethod = n, this.redirectTarget = o, this.iframeNotifyParentOrigin = c, this.iframeScriptOrigin = l, this.silent_redirect_uri = h, this.silentRequestTimeoutInSeconds = p, this.automaticSilentRenew = g, this.validateSubOnSilentRenew = S, this.includeIdTokenInSilentRenew = v, this.monitorSession = b, this.monitorAnonymousSession = _, this.checkSessionIntervalInSeconds = m, this.stopCheckSessionOnError = a, this.query_status_response_type = E, this.revokeTokenTypes = d, this.revokeTokensOnSignout = u, this.includeIdTokenInSilentSignout = w, this.accessTokenExpiringNotificationTimeInSeconds = y, k)
      this.userStore = k;
    else {
      const x = typeof window < "u" ? window.sessionStorage : new ye();
      this.userStore = new be({ store: x });
    }
  }
}, ae = class extends Ee {
  constructor({
    silentRequestTimeoutInSeconds: e = Te
  }) {
    super(), this._logger = new f("IFrameWindow"), this._timeoutInSeconds = e, this._frame = ae.createHiddenIframe(), this._window = this._frame.contentWindow;
  }
  static createHiddenIframe() {
    const e = window.document.createElement("iframe");
    return e.style.visibility = "hidden", e.style.position = "fixed", e.style.left = "-1000px", e.style.top = "0", e.width = "0", e.height = "0", window.document.body.appendChild(e), e;
  }
  async navigate(e) {
    this._logger.debug("navigate: Using timeout of:", this._timeoutInSeconds);
    const t = setTimeout(() => this._abort.raise(new ce("IFrame timed out without a response")), this._timeoutInSeconds * 1e3);
    return this._disposeHandlers.add(() => clearTimeout(t)), await super.navigate(e);
  }
  close() {
    var e;
    this._frame && (this._frame.parentNode && (this._frame.addEventListener("load", (t) => {
      var s;
      const r = t.target;
      (s = r.parentNode) == null || s.removeChild(r), this._abort.raise(new Error("IFrame removed from DOM"));
    }, !0), (e = this._frame.contentWindow) == null || e.location.replace("about:blank")), this._frame = null), this._window = null;
  }
  static notifyParent(e, t) {
    return super._notifyParent(window.parent, e, !1, t);
  }
}, kt = class {
  constructor(e) {
    this._settings = e, this._logger = new f("IFrameNavigator");
  }
  async prepare({
    silentRequestTimeoutInSeconds: e = this._settings.silentRequestTimeoutInSeconds
  }) {
    return new ae({ silentRequestTimeoutInSeconds: e });
  }
  async callback(e) {
    this._logger.create("callback"), ae.notifyParent(e, this._settings.iframeNotifyParentOrigin);
  }
}, Et = 500, xt = 1e3, me = class extends Ee {
  constructor({
    popupWindowTarget: e = Re,
    popupWindowFeatures: t = {}
  }) {
    super(), this._logger = new f("PopupWindow");
    const s = we.center({ ...xe, ...t });
    this._window = window.open(void 0, e, we.serialize(s)), t.closePopupWindowAfterInSeconds && t.closePopupWindowAfterInSeconds > 0 && setTimeout(() => {
      if (!this._window || typeof this._window.closed != "boolean" || this._window.closed) {
        this._abort.raise(new Error("Popup blocked by user"));
        return;
      }
      this.close();
    }, t.closePopupWindowAfterInSeconds * xt);
  }
  async navigate(e) {
    var t;
    (t = this._window) == null || t.focus();
    const s = setInterval(() => {
      (!this._window || this._window.closed) && this._abort.raise(new Error("Popup closed by user"));
    }, Et);
    return this._disposeHandlers.add(() => clearInterval(s)), await super.navigate(e);
  }
  close() {
    this._window && (this._window.closed || (this._window.close(), this._abort.raise(new Error("Popup closed")))), this._window = null;
  }
  static notifyOpener(e, t) {
    if (!window.opener)
      throw new Error("No window.opener. Can't complete notification.");
    return super._notifyParent(window.opener, e, t);
  }
}, Rt = class {
  constructor(e) {
    this._settings = e, this._logger = new f("PopupNavigator");
  }
  async prepare({
    popupWindowFeatures: e = this._settings.popupWindowFeatures,
    popupWindowTarget: t = this._settings.popupWindowTarget
  }) {
    return new me({ popupWindowFeatures: e, popupWindowTarget: t });
  }
  async callback(e, { keepOpen: t = !1 }) {
    this._logger.create("callback"), me.notifyOpener(e, t);
  }
}, Tt = class {
  constructor(e) {
    this._settings = e, this._logger = new f("RedirectNavigator");
  }
  async prepare({
    redirectMethod: e = this._settings.redirectMethod,
    redirectTarget: t = this._settings.redirectTarget
  }) {
    var s;
    this._logger.create("prepare");
    let r = window.self;
    t === "top" && (r = (s = window.top) != null ? s : window.self);
    const i = r.location[e].bind(r.location);
    let n;
    return {
      navigate: async (o) => {
        this._logger.create("navigate");
        const c = new Promise((l, h) => {
          n = h;
        });
        return i(o.url), await c;
      },
      close: () => {
        this._logger.create("close"), n == null || n(new Error("Redirect aborted")), r.stop();
      }
    };
  }
  async callback() {
  }
}, Ct = class extends et {
  constructor(e) {
    super({ expiringNotificationTimeInSeconds: e.accessTokenExpiringNotificationTimeInSeconds }), this._logger = new f("UserManagerEvents"), this._userLoaded = new O("User loaded"), this._userUnloaded = new O("User unloaded"), this._silentRenewError = new O("Silent renew error"), this._userSignedIn = new O("User signed in"), this._userSignedOut = new O("User signed out"), this._userSessionChanged = new O("User session changed");
  }
  load(e, t = !0) {
    super.load(e), t && this._userLoaded.raise(e);
  }
  unload() {
    super.unload(), this._userUnloaded.raise();
  }
  /**
   * Add callback: Raised when a user session has been established (or re-established).
   */
  addUserLoaded(e) {
    return this._userLoaded.addHandler(e);
  }
  /**
   * Remove callback: Raised when a user session has been established (or re-established).
   */
  removeUserLoaded(e) {
    return this._userLoaded.removeHandler(e);
  }
  /**
   * Add callback: Raised when a user session has been terminated.
   */
  addUserUnloaded(e) {
    return this._userUnloaded.addHandler(e);
  }
  /**
   * Remove callback: Raised when a user session has been terminated.
   */
  removeUserUnloaded(e) {
    return this._userUnloaded.removeHandler(e);
  }
  /**
   * Add callback: Raised when the automatic silent renew has failed.
   */
  addSilentRenewError(e) {
    return this._silentRenewError.addHandler(e);
  }
  /**
   * Remove callback: Raised when the automatic silent renew has failed.
   */
  removeSilentRenewError(e) {
    return this._silentRenewError.removeHandler(e);
  }
  /**
   * @internal
   */
  _raiseSilentRenewError(e) {
    this._silentRenewError.raise(e);
  }
  /**
   * Add callback: Raised when the user is signed in (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */
  addUserSignedIn(e) {
    return this._userSignedIn.addHandler(e);
  }
  /**
   * Remove callback: Raised when the user is signed in (when `monitorSession` is set).
   */
  removeUserSignedIn(e) {
    this._userSignedIn.removeHandler(e);
  }
  /**
   * @internal
   */
  _raiseUserSignedIn() {
    this._userSignedIn.raise();
  }
  /**
   * Add callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */
  addUserSignedOut(e) {
    return this._userSignedOut.addHandler(e);
  }
  /**
   * Remove callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   */
  removeUserSignedOut(e) {
    this._userSignedOut.removeHandler(e);
  }
  /**
   * @internal
   */
  _raiseUserSignedOut() {
    this._userSignedOut.raise();
  }
  /**
   * Add callback: Raised when the user session changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */
  addUserSessionChanged(e) {
    return this._userSessionChanged.addHandler(e);
  }
  /**
   * Remove callback: Raised when the user session changed (when `monitorSession` is set).
   */
  removeUserSessionChanged(e) {
    this._userSessionChanged.removeHandler(e);
  }
  /**
   * @internal
   */
  _raiseUserSessionChanged() {
    this._userSessionChanged.raise();
  }
}, It = class {
  constructor(e) {
    this._userManager = e, this._logger = new f("SilentRenewService"), this._isStarted = !1, this._retryTimer = new C("Retry Silent Renew"), this._tokenExpiring = async () => {
      const t = this._logger.create("_tokenExpiring");
      try {
        await this._userManager.signinSilent(), t.debug("silent token renewal successful");
      } catch (s) {
        if (s instanceof ce) {
          t.warn("ErrorTimeout from signinSilent:", s, "retry in 5s"), this._retryTimer.init(5);
          return;
        }
        t.error("Error from signinSilent:", s), this._userManager.events._raiseSilentRenewError(s);
      }
    };
  }
  async start() {
    const e = this._logger.create("start");
    if (!this._isStarted) {
      this._isStarted = !0, this._userManager.events.addAccessTokenExpiring(this._tokenExpiring), this._retryTimer.addHandler(this._tokenExpiring);
      try {
        await this._userManager.getUser();
      } catch (t) {
        e.error("getUser error", t);
      }
    }
  }
  stop() {
    this._isStarted && (this._retryTimer.cancel(), this._retryTimer.removeHandler(this._tokenExpiring), this._userManager.events.removeAccessTokenExpiring(this._tokenExpiring), this._isStarted = !1);
  }
}, Ut = class {
  constructor(e, t) {
    this.refresh_token = e.refresh_token, this.id_token = e.id_token, this.session_state = e.session_state, this.scope = e.scope, this.profile = e.profile, this.resource = t, this.data = e.state;
  }
}, Mt = class {
  constructor(e, t, s, r) {
    this._logger = new f("UserManager"), this.settings = new bt(e), this._client = new vt(e), this._redirectNavigator = t ?? new Tt(this.settings), this._popupNavigator = s ?? new Rt(this.settings), this._iframeNavigator = r ?? new kt(this.settings), this._events = new Ct(this.settings), this._silentRenewService = new It(this), this.settings.automaticSilentRenew && this.startSilentRenew(), this._sessionMonitor = null, this.settings.monitorSession && (this._sessionMonitor = new mt(this));
  }
  /** Returns an object used to register for events raised by the `UserManager`. */
  get events() {
    return this._events;
  }
  /** Returns an object used to access the metadata configuration of the OIDC provider. */
  get metadataService() {
    return this._client.metadataService;
  }
  /**
   * Returns promise to load the `User` object for the currently authenticated user.
   */
  async getUser() {
    const e = this._logger.create("getUser"), t = await this._loadUser();
    return t ? (e.info("user loaded"), this._events.load(t, !1), t) : (e.info("user not found in storage"), null);
  }
  /**
   * Returns promise to remove from any storage the currently authenticated user.
   */
  async removeUser() {
    const e = this._logger.create("removeUser");
    await this.storeUser(null), e.info("user removed from storage"), this._events.unload();
  }
  /**
   * Returns promise to trigger a redirect of the current window to the authorization endpoint.
   */
  async signinRedirect(e = {}) {
    this._logger.create("signinRedirect");
    const {
      redirectMethod: t,
      ...s
    } = e, r = await this._redirectNavigator.prepare({ redirectMethod: t });
    await this._signinStart({
      request_type: "si:r",
      ...s
    }, r);
  }
  /**
   * Returns promise to process response from the authorization endpoint. The result of the promise is the authenticated `User`.
   */
  async signinRedirectCallback(e = window.location.href) {
    const t = this._logger.create("signinRedirectCallback"), s = await this._signinEnd(e);
    return s.profile && s.profile.sub ? t.info("success, signed in subject", s.profile.sub) : t.info("no subject"), s;
  }
  /**
   * Returns promise to process the signin with user/password. The result of the promise is the authenticated `User`.
   *
   * Throws an ErrorResponse in case of wrong authentication.
   */
  async signinResourceOwnerCredentials({
    username: e,
    password: t,
    skipUserInfo: s = !1
  }) {
    const r = this._logger.create("signinResourceOwnerCredential"), i = await this._client.processResourceOwnerPasswordCredentials({ username: e, password: t, skipUserInfo: s, extraTokenParams: this.settings.extraTokenParams });
    r.debug("got signin response");
    const n = await this._buildUser(i);
    return n.profile && n.profile.sub ? r.info("success, signed in subject", n.profile.sub) : r.info("no subject"), n;
  }
  /**
   * Returns promise to trigger a request (via a popup window) to the authorization endpoint. The result of the promise is the authenticated `User`.
   */
  async signinPopup(e = {}) {
    const t = this._logger.create("signinPopup"), {
      popupWindowFeatures: s,
      popupWindowTarget: r,
      ...i
    } = e, n = this.settings.popup_redirect_uri;
    n || t.throw(new Error("No popup_redirect_uri configured"));
    const o = await this._popupNavigator.prepare({ popupWindowFeatures: s, popupWindowTarget: r }), c = await this._signin({
      request_type: "si:p",
      redirect_uri: n,
      display: "popup",
      ...i
    }, o);
    return c && (c.profile && c.profile.sub ? t.info("success, signed in subject", c.profile.sub) : t.info("no subject")), c;
  }
  /**
   * Returns promise to notify the opening window of response from the authorization endpoint.
   */
  async signinPopupCallback(e = window.location.href, t = !1) {
    const s = this._logger.create("signinPopupCallback");
    await this._popupNavigator.callback(e, { keepOpen: t }), s.info("success");
  }
  /**
   * Returns promise to trigger a silent request (via an iframe) to the authorization endpoint.
   * The result of the promise is the authenticated `User`.
   */
  async signinSilent(e = {}) {
    var t;
    const s = this._logger.create("signinSilent"), {
      silentRequestTimeoutInSeconds: r,
      resource: i,
      ...n
    } = e;
    let o = await this._loadUser();
    if (o != null && o.refresh_token) {
      s.debug("using refresh token");
      const p = new Ut(o, i);
      return await this._useRefreshToken(p);
    }
    const c = this.settings.silent_redirect_uri;
    c || s.throw(new Error("No silent_redirect_uri configured"));
    let l;
    o && this.settings.validateSubOnSilentRenew && (s.debug("subject prior to silent renew:", o.profile.sub), l = o.profile.sub);
    const h = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds: r });
    return o = await this._signin({
      request_type: "si:s",
      redirect_uri: c,
      prompt: "none",
      id_token_hint: this.settings.includeIdTokenInSilentRenew ? o == null ? void 0 : o.id_token : void 0,
      ...n
    }, h, l), o && ((t = o.profile) != null && t.sub ? s.info("success, signed in subject", o.profile.sub) : s.info("no subject")), o;
  }
  async _useRefreshToken(e) {
    const t = await this._client.useRefreshToken({
      state: e,
      timeoutInSeconds: this.settings.silentRequestTimeoutInSeconds
    }), s = new z({ ...e, ...t });
    return await this.storeUser(s), this._events.load(s), s;
  }
  /**
   * Returns promise to notify the parent window of response from the authorization endpoint.
   */
  async signinSilentCallback(e = window.location.href) {
    const t = this._logger.create("signinSilentCallback");
    await this._iframeNavigator.callback(e), t.info("success");
  }
  async signinCallback(e = window.location.href) {
    const { state: t } = await this._client.readSigninResponseState(e);
    switch (t.request_type) {
      case "si:r":
        return await this.signinRedirectCallback(e);
      case "si:p":
        return await this.signinPopupCallback(e);
      case "si:s":
        return await this.signinSilentCallback(e);
      default:
        throw new Error("invalid response_type in state");
    }
  }
  async signoutCallback(e = window.location.href, t = !1) {
    const { state: s } = await this._client.readSignoutResponseState(e);
    if (s)
      switch (s.request_type) {
        case "so:r":
          return await this.signoutRedirectCallback(e);
        case "so:p":
          await this.signoutPopupCallback(e, t);
          break;
        case "so:s":
          await this.signoutSilentCallback(e);
          break;
        default:
          throw new Error("invalid response_type in state");
      }
  }
  /**
   * Returns promise to query OP for user's current signin status. Returns object with session_state and subject identifier.
   */
  async querySessionStatus(e = {}) {
    const t = this._logger.create("querySessionStatus"), {
      silentRequestTimeoutInSeconds: s,
      ...r
    } = e, i = this.settings.silent_redirect_uri;
    i || t.throw(new Error("No silent_redirect_uri configured"));
    const n = await this._loadUser(), o = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds: s }), c = await this._signinStart({
      request_type: "si:s",
      // this acts like a signin silent
      redirect_uri: i,
      prompt: "none",
      id_token_hint: this.settings.includeIdTokenInSilentRenew ? n == null ? void 0 : n.id_token : void 0,
      response_type: this.settings.query_status_response_type,
      scope: "openid",
      skipUserInfo: !0,
      ...r
    }, o);
    try {
      const l = await this._client.processSigninResponse(c.url);
      return t.debug("got signin response"), l.session_state && l.profile.sub ? (t.info("success for subject", l.profile.sub), {
        session_state: l.session_state,
        sub: l.profile.sub,
        sid: l.profile.sid
      }) : (t.info("success, user not authenticated"), null);
    } catch (l) {
      if (this.settings.monitorAnonymousSession && l instanceof N)
        switch (l.error) {
          case "login_required":
          case "consent_required":
          case "interaction_required":
          case "account_selection_required":
            return t.info("success for anonymous user"), {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              session_state: l.session_state
            };
        }
      throw l;
    }
  }
  async _signin(e, t, s) {
    const r = await this._signinStart(e, t);
    return await this._signinEnd(r.url, s);
  }
  async _signinStart(e, t) {
    const s = this._logger.create("_signinStart");
    try {
      const r = await this._client.createSigninRequest(e);
      return s.debug("got signin request"), await t.navigate({
        url: r.url,
        state: r.state.id,
        response_mode: r.state.response_mode,
        scriptOrigin: this.settings.iframeScriptOrigin
      });
    } catch (r) {
      throw s.debug("error after preparing navigator, closing navigator window"), t.close(), r;
    }
  }
  async _signinEnd(e, t) {
    const s = this._logger.create("_signinEnd"), r = await this._client.processSigninResponse(e);
    return s.debug("got signin response"), await this._buildUser(r, t);
  }
  async _buildUser(e, t) {
    const s = this._logger.create("_buildUser"), r = new z(e);
    if (t) {
      if (t !== r.profile.sub)
        throw s.debug("current user does not match user returned from signin. sub from signin:", r.profile.sub), new N({ ...e, error: "login_required" });
      s.debug("current user matches user returned from signin");
    }
    return await this.storeUser(r), s.debug("user stored"), this._events.load(r), r;
  }
  /**
   * Returns promise to trigger a redirect of the current window to the end session endpoint.
   */
  async signoutRedirect(e = {}) {
    const t = this._logger.create("signoutRedirect"), {
      redirectMethod: s,
      ...r
    } = e, i = await this._redirectNavigator.prepare({ redirectMethod: s });
    await this._signoutStart({
      request_type: "so:r",
      post_logout_redirect_uri: this.settings.post_logout_redirect_uri,
      ...r
    }, i), t.info("success");
  }
  /**
   * Returns promise to process response from the end session endpoint.
   */
  async signoutRedirectCallback(e = window.location.href) {
    const t = this._logger.create("signoutRedirectCallback"), s = await this._signoutEnd(e);
    return t.info("success"), s;
  }
  /**
   * Returns promise to trigger a redirect of a popup window window to the end session endpoint.
   */
  async signoutPopup(e = {}) {
    const t = this._logger.create("signoutPopup"), {
      popupWindowFeatures: s,
      popupWindowTarget: r,
      ...i
    } = e, n = this.settings.popup_post_logout_redirect_uri, o = await this._popupNavigator.prepare({ popupWindowFeatures: s, popupWindowTarget: r });
    await this._signout({
      request_type: "so:p",
      post_logout_redirect_uri: n,
      // we're putting a dummy entry in here because we
      // need a unique id from the state for notification
      // to the parent window, which is necessary if we
      // plan to return back to the client after signout
      // and so we can close the popup after signout
      state: n == null ? void 0 : {},
      ...i
    }, o), t.info("success");
  }
  /**
   * Returns promise to process response from the end session endpoint from a popup window.
   */
  async signoutPopupCallback(e = window.location.href, t = !1) {
    const s = this._logger.create("signoutPopupCallback");
    await this._popupNavigator.callback(e, { keepOpen: t }), s.info("success");
  }
  async _signout(e, t) {
    const s = await this._signoutStart(e, t);
    return await this._signoutEnd(s.url);
  }
  async _signoutStart(e = {}, t) {
    var s;
    const r = this._logger.create("_signoutStart");
    try {
      const i = await this._loadUser();
      r.debug("loaded current user from storage"), this.settings.revokeTokensOnSignout && await this._revokeInternal(i);
      const n = e.id_token_hint || i && i.id_token;
      n && (r.debug("setting id_token_hint in signout request"), e.id_token_hint = n), await this.removeUser(), r.debug("user removed, creating signout request");
      const o = await this._client.createSignoutRequest(e);
      return r.debug("got signout request"), await t.navigate({
        url: o.url,
        state: (s = o.state) == null ? void 0 : s.id,
        scriptOrigin: this.settings.iframeScriptOrigin
      });
    } catch (i) {
      throw r.debug("error after preparing navigator, closing navigator window"), t.close(), i;
    }
  }
  async _signoutEnd(e) {
    const t = this._logger.create("_signoutEnd"), s = await this._client.processSignoutResponse(e);
    return t.debug("got signout response"), s;
  }
  /**
   * Returns promise to trigger a silent request (via an iframe) to the end session endpoint.
   */
  async signoutSilent(e = {}) {
    var t;
    const s = this._logger.create("signoutSilent"), {
      silentRequestTimeoutInSeconds: r,
      ...i
    } = e, n = this.settings.includeIdTokenInSilentSignout ? (t = await this._loadUser()) == null ? void 0 : t.id_token : void 0, o = this.settings.popup_post_logout_redirect_uri, c = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds: r });
    await this._signout({
      request_type: "so:s",
      post_logout_redirect_uri: o,
      id_token_hint: n,
      ...i
    }, c), s.info("success");
  }
  /**
   * Returns promise to notify the parent window of response from the end session endpoint.
   */
  async signoutSilentCallback(e = window.location.href) {
    const t = this._logger.create("signoutSilentCallback");
    await this._iframeNavigator.callback(e), t.info("success");
  }
  async revokeTokens(e) {
    const t = await this._loadUser();
    await this._revokeInternal(t, e);
  }
  async _revokeInternal(e, t = this.settings.revokeTokenTypes) {
    const s = this._logger.create("_revokeInternal");
    if (!e)
      return;
    const r = t.filter((i) => typeof e[i] == "string");
    if (!r.length) {
      s.debug("no need to revoke due to no token(s)");
      return;
    }
    for (const i of r)
      await this._client.revokeToken(
        e[i],
        // eslint-disable-line @typescript-eslint/no-non-null-assertion
        i
      ), s.info(`${i} revoked successfully`), i !== "access_token" && (e[i] = null);
    await this.storeUser(e), s.debug("user stored"), this._events.load(e);
  }
  /**
   * Enables silent renew for the `UserManager`.
   */
  startSilentRenew() {
    this._logger.create("startSilentRenew"), this._silentRenewService.start();
  }
  /**
   * Disables silent renew for the `UserManager`.
   */
  stopSilentRenew() {
    this._silentRenewService.stop();
  }
  get _userStoreKey() {
    return `user:${this.settings.authority}:${this.settings.client_id}`;
  }
  async _loadUser() {
    const e = this._logger.create("_loadUser"), t = await this.settings.userStore.get(this._userStoreKey);
    return t ? (e.debug("user storageString loaded"), z.fromStorageString(t)) : (e.debug("no user storageString"), null);
  }
  async storeUser(e) {
    const t = this._logger.create("storeUser");
    if (e) {
      t.debug("storing user");
      const s = e.toStorageString();
      await this.settings.userStore.set(this._userStoreKey, s);
    } else
      this._logger.debug("removing user"), await this.settings.userStore.remove(this._userStoreKey);
  }
  /**
   * Removes stale state entries in storage for incomplete authorize requests.
   */
  async clearStaleState() {
    await this._client.clearStaleState();
  }
};
const Se = Pe("App", {
  web: () => import("./web-ByWJkPaj.js").then((e) => new e.AppWeb())
});
class Ht {
  constructor() {
    B(this, "_logger", new f("MobileNavigator"));
  }
  async prepare(t) {
    return this._logger.create("prepare"), new Pt(t);
  }
  async callback(t, { keepOpen: s = !1 }) {
    console.log("in the navigator callback", t, s), te.close();
  }
}
class Pt {
  constructor(t) {
    B(this, "_logger", new f("MobileWindow"));
    B(this, "_isClosed", !0);
    this.redirectUrl = t;
  }
  async navigate(t) {
    const { url: s } = await new Promise((r) => {
      const i = (n) => {
        console.log("listener handleappopen", n), window.location.search === "" && n.url && n.url.indexOf("?") >= 0 && n.url.split("?")[1].split("&").map((l) => {
          const h = l.split("=");
          return { name: h[0], value: h[1] };
        }).some((l) => l.name === "code") && (console.log("gonna resolve in listener", n.url), r({ url: n.url }));
      };
      Se.addListener("appUrlOpen", i), te.open({ url: t.url });
    });
    return Se.removeAllListeners(), console.log("about to return url from navigate"), { url: s };
  }
  // TODO: oidc-client-ts impose a sync method but an async one is needed because of Capacitor Browser
  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  async close() {
    const t = this._logger.create("close");
    this._isClosed || await te.close().catch((s) => t.error(s)), t.debug("success");
  }
}
export {
  Ht as M,
  z as U,
  Mt as a,
  Pt as b
};
//# sourceMappingURL=CustomPopupNavigator-Bz9uYcKp.js.map
